import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AccountStore } from '../store/accountStore'

export const AccountContext = createContext<AccountStore | null>(null)

export const useAccountContext = () => {
  const context = useContext(AccountContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AccountContext')

  return context
}

export const AccountProvider = observer(({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const user = entities.usersStore.user
  const store = useMemo(() => {
    if (!user) return null

    return new AccountStore(user, entities)
  }, [entities, user])

  useEffect(() => {
    return () => {
      if (store) store.reset()
    }
  }, [store])

  if (!store) return <SpinnerLoader ariaLabel={'AccountProvider'} />

  return <AccountContext.Provider value={store}>{children}</AccountContext.Provider>
})
